import React from 'react';

import { Select } from '../../components';

const FilterBy = ({ filterBy, setFilterBy, options, placeholder, className = "select-container mb-3" }) => {
  return (
    <Select
      {...{
        className,
        placeholder,
        options,
        onSelectionChange: (by) => setFilterBy(by),
        field: { name: 'filterBy', value: filterBy },
        form: { setFieldValue: () => { } },
      }}
    />
  );
}

export default FilterBy;
